import type { ReactNode } from 'react';

export type WarningBannerProps = {
  children: ReactNode;
};

export function WarningBanner({ children }: WarningBannerProps) {
  return (
    <div className="p-2 bg-warning text-white d-flex flex-wrap gap-2 align-items-center justify-content-center">
      {children}
    </div>
  );
}
